import { graphql } from '@api/generated';

import { getClient } from '../../../api/client';
import { InteractionChannel } from '@api/generated/graphql';
import IAppLogger from '@app/lib/IAppLogger';

const RETRY_CLASSIFICATION_TIMEOUT_MS = 10 * 1000; // 10 seconds

const CHANNEL_CLASSIFICATION_QUERY = graphql(`
  query channelClassification(
    $tenantId: ID!
    $channelId: ID!
    $channelType: InteractionChannel!
  ) {
    channelClassification(
      tenantId: $tenantId
      channelId: $channelId
      channelType: $channelType
    ) {
      typeName
    }
  }
`);

async function getClassificationTypeName(
  tenantId: string,
  channelId: string,
  channel: InteractionChannel,
  logger: IAppLogger,
): Promise<string | null> {
  const startTime = Date.now();

  const fetchClassification = async (): Promise<string | null> => {
    try {
      const { data } = await getClient().query({
        query: CHANNEL_CLASSIFICATION_QUERY,
        variables: {
          tenantId,
          channelId,
          channelType: channel,
        },
        fetchPolicy: 'network-only',
      });

      if (data?.channelClassification?.typeName) {
        return data.channelClassification.typeName;
      }
    } catch (error) {
      logger.error('Unable to fetch classification type', error);
    }

    if (Date.now() - startTime < RETRY_CLASSIFICATION_TIMEOUT_MS) {
      return new Promise((resolve) => {
        setTimeout(async () => {
          resolve(await fetchClassification());
        }, 1000); // Retry after 1 second
      });
    }

    return null;
  };

  return fetchClassification();
}

export default getClassificationTypeName;
